import { jsx as _jsx } from "react/jsx-runtime";
import { DataTable, FlexBox, Spinner, Switch, Text, } from '@dixa/lib-shared-habla';
export const EmailAccountsList = ({ accounts, onStatusChange, isLoading, disabled, }) => {
    if (isLoading) {
        return (_jsx(FlexBox, Object.assign({ height: "100%", alignItems: "center", justifyContent: "center" }, { children: _jsx(Spinner, {}) })));
    }
    return (_jsx(DataTable, { data: accounts, columns: [
            {
                label: 'Email account',
                selector: ({ address }) => _jsx(Text.Paragraph, { children: address }),
            },
            {
                label: 'Enabled',
                selector: ({ enabled, settings, address }) => (_jsx(Switch, { name: address, value: address, checked: enabled, disabled: disabled, onChange: () => onStatusChange({
                        newStatus: !enabled,
                        emailAddress: address,
                        settings: settings,
                    }) })),
                style: {
                    width: 0,
                },
            },
        ] }));
};
